import React from 'react';
import { Grid } from '@mui/material';

const Rule = ({
	id,
	parentId,
	field,
	operator,
	value,
	translations,
	schema: {
		classNames,
		controls,
		fields,
		getInputType,
		getLevel,
		getOperators,
		getValueEditorType,
		getValues,
		onPropChange,
		onRuleRemove,
	},
}) => {
	const onElementChanged = (property, value) => {
		onPropChange(property, value, id);
	};

	const onFieldChanged = (value) => {
		onElementChanged('field', value);
	};

	const onOperatorChanged = (value) => {
		onElementChanged('operator', value);
	};

	const onValueChanged = (value) => {
		onElementChanged('value', value);
	};

	const removeRule = (event) => {
		event.preventDefault();
		event.stopPropagation();

		onRuleRemove(id, parentId);
	};

	const fieldData = fields.find((f) => f.name === field) || null;
	const level = getLevel(id);

	return (
		<Grid
			item
			container
			direction="row"
			justifyContent="flex-start"
			alignItems="center"
			spacing={2}
			className={`rule ${classNames.rule}`}
			data-rule-id={id}
			data-level={level}
		>
			<controls.fieldSelector
				options={fields}
				title={translations.fields.title}
				value={field}
				operator={operator}
				className={`rule-fields ${classNames.fields}`}
				handleOnChange={onFieldChanged}
				level={level}
			/>
			<controls.operatorSelector
				field={field}
				fieldData={fieldData}
				title={translations.operators.title}
				options={getOperators(field)}
				value={operator}
				className={`rule-operators ${classNames.operators}`}
				handleOnChange={onOperatorChanged}
				level={level}
			/>
			<controls.valueEditor
				field={field}
				fieldData={fieldData}
				title={translations.value.title}
				operator={operator}
				value={value}
				type={getValueEditorType(field, operator)}
				inputType={getInputType(field, operator)}
				values={getValues(field, operator)}
				className={`rule-value ${classNames.value}`}
				handleOnChange={onValueChanged}
				level={level}
			/>
			<controls.removeRuleAction
				label={translations.removeRule.label}
				title={translations.removeRule.title}
				className={`iconBtn`}
				handleOnClick={removeRule}
				level={level}
			/>
		</Grid>
	);
};

Rule.defaultProps = {
	id: null,
	parentId: null,
	field: null,
	operator: null,
	value: null,
	schema: null,
};

Rule.displayName = 'Rule';

export default Rule;
